import React, { useState } from "react";
import PropTypes from "prop-types";
import { Container, Box, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { getCrmProductsPerformance } from "../../api";
import { useAnalyticsFetch } from "./hooks/useAnalyticsFetch";
import BarChartCard from "./components/BarChartCard";

const METRIC_OPTIONS = [
  { value: "top_selling", label: "Top Selling" },
  { value: "worst_selling", label: "Worst Selling" },
  { value: "revenue", label: "Revenue" },
  { value: "quantity", label: "Quantity" },
];

const LIMIT_OPTIONS = [10, 20, 50, 100];

const Products = ({ filter, startDate, endDate }) => {
  const [metric, setMetric] = useState("top_selling");
  const [limit, setLimit] = useState(10);

  const { data, loading } = useAnalyticsFetch(getCrmProductsPerformance, [
    filter,
    startDate,
    endDate,
    metric,
    limit,
  ]);

  return (
    <Container sx={{ paddingLeft: "0 !important", paddingRight: "0 !important" }}>
      <Box sx={{ display: "flex", gap: "1rem", marginBottom: "1rem", flexWrap: "wrap" }}>
        <FormControl size="small" sx={{ minWidth: 160 }}>
          <InputLabel id="product-metric-label">Metric</InputLabel>
          <Select
            labelId="product-metric-label"
            label="Metric"
            value={metric}
            onChange={(event) => setMetric(event.target.value)}
          >
            {METRIC_OPTIONS.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl size="small" sx={{ minWidth: 120 }}>
          <InputLabel id="product-limit-label">Limit</InputLabel>
          <Select
            labelId="product-limit-label"
            label="Limit"
            value={limit}
            onChange={(event) => setLimit(event.target.value)}
          >
            {LIMIT_OPTIONS.map((option) => (
              <MenuItem key={option} value={option}>
                Top {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      <BarChartCard
        title="Product Performance"
        labels={data?.chart?.labels || []}
        series={data?.chart?.series || []}
        label={METRIC_OPTIONS.find((option) => option.value === metric)?.label || "Value"}
        horizontal
        loading={loading}
        height={Math.max(300, (data?.chart?.labels?.length || 0) * 28)}
        currency={metric === "revenue"}
      />
    </Container>
  );
};

Products.propTypes = {
  filter: PropTypes.string.isRequired,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
};

export default Products;
